import { render } from "./VideoForm.vue?vue&type=template&id=41851120&scoped=true"
import script from "./VideoForm.vue?vue&type=script&lang=js"
export * from "./VideoForm.vue?vue&type=script&lang=js"

import "./VideoForm.vue?vue&type=style&index=0&id=41851120&scoped=true&lang=css"

import exportComponent from "D:\\Coding\\welikethespeech\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41851120"]])

export default __exports__